// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"7c71ffa0","564":"7c71ffa0","704":"7c71ffa0","964":"7c71ffa0"}[chunkId] + ".chunk.css";
};